import { type FC } from 'react';

import { useCardOfferDataContext } from '@/microfrontends/listing/shared/context/selectors/cardData';

import { extractUndefined } from '@/packages/utils/extractUndefined';

import { Factoids } from './Factoids';

export const FactoidsContainer: FC = () => {
  const {
    terms: { extra },
  } = useCardOfferDataContext();

  if (!extra) {
    return null;
  }

  return <Factoids iconType={extractUndefined(extra.iconType)} title={extra.title} />;
};
